module.exports = __webpack_public_path__ + "img/Server-c.9d70072.svg";